import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DistributorsComponent } from './distributors.component';
import {DistributorDetailComponent} from './distributor-detail/distributor-detail.component';

const routes: Routes = [
  {
    path: '',
    component: DistributorsComponent
  },
  {
    path: 'distributor-detail/:id',
    component: DistributorDetailComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DistributorsRoutingModule { }
